/**
 * Get the CSS class for a given quote status.
 * @param {string} status - The status of the quote.
 * @returns {string} - The corresponding CSS class.
 */
export function getStatusClass(status) {
    if (status === "NEW") {
        return "status-new";
    } else if ("CANCELLED" === status) {
        return "status-cancelled";
    } else if ("DRAFT" === status) {
        return "status-draft";
    } else if ("EXPIRED" === status) {
        return "status-expired";
    } else if ("REJECTED" === status) {
        return "status-rejected";
    } {
        return {};
    }
}

/**
 * Determine if a quote can be cancelled based on its status.
 * @param {string} status - The status of the quote.
 * @returns {boolean} - True if the quote can be cancelled, false otherwise.
 */
export function canCancelQuote(status) {
    return status === "NEW" || status === "DRAFT";
}

/**
 * Determine if a quote can be converted based on its status.
 * @param {string} status - The status of the quote.
 * @returns {boolean} - True if the quote can be converted, false otherwise.
 */
export function canConvertQuote(status) {
    return status === "NEW";
}

/**
 * Determine if a quote PDF can be downloaded based on its status.
 * @param {string} status - The status of the quote.
 * @returns {boolean} - True if the quote PDF can be downloaded, false otherwise.
 */
export function canDownloadQuotePDF(status) {
    return status === "NEW";
}

/**
 * Determine if a quote can be duplicated based on its status.
 * @param {string} status - The status of the quote.
 * @returns {boolean} - True if the quote can be duplicated, false otherwise.
 */
export function canDuplicateQuote(status) {
    return status === "NEW" || status === "DRAFT";
}